// Watchboard.js
import React, { useEffect } from "react";
import "./watchboard.css"; // new CSS (next section)
import ChatbotGate from "../../../ChatbotGate";
import useAuth from "../../../hooks/useAuth";

export default function Watchboard() {
  useAuth();
  useEffect(() => {
    document.body.classList.add("page-watchboard");
    return () => document.body.classList.remove("page-watchboard");
  }, []);

  return (
    <div className="watchboard">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <ChatbotGate
          token={localStorage.getItem("access_token")}
          height="100%"
          mountId="salesplay-chatbot"
        />
      </div>
      {/* <ChatbotGate
        token={localStorage.getItem("access_token")}
        mountId="salesplay-chatbot"
        height="calc(100vh - 64px)"            // adjust if your header height differs
      /> */}
    </div>
  );
}
